/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import {Grid, GridCellProps, GridColumn, GridDetailRowProps} from "@progress/kendo-react-grid"
import {useInternationalization} from "@progress/kendo-react-intl"
import {Tooltip} from "@progress/kendo-react-tooltip"
import {useContext} from "react"
import DefectGrid from "../DefectGrid"
import {AnnualTestsContext} from "../VehicleGrid"

export default function AnnualTestGrid(props: GridDetailRowProps) {
    const DateFormatCell = (props: GridCellProps) => {
        const intl = useInternationalization()
        const dateVal =
            props.dataItem[`${props.field}`] == null || props.dataItem[`${props.field}`] === ""
                ? ""
                : intl.formatDate(new Date(props.dataItem[`${props.field}`]))
        return <td>{dateVal}</td>
    }
    const TooltipCell = (props: GridCellProps) => (
        <td title={props.dataItem[`${props.field}`]}>{props.dataItem[`${props.field}`]}</td>
    )

    const ExpandSelectionCell = (props: GridCellProps) => {
        const {toggleAnnualTestExpansion} = useContext(AnnualTestsContext)
        const annualTest = props.dataItem
        return (
            <td className="k-hierarchy-cell">
                {annualTest.defects.length > 0 ? (
                    <a
                        onClick={() =>
                            toggleAnnualTestExpansion(
                                annualTest.vehicleId,
                                annualTest.annualTestId,
                                !annualTest.expanded,
                            )
                        }
                        className={`k-icon k-i-${annualTest.expanded ? "minus" : "plus"}`}
                        href="#"
                    ></a>
                ) : (
                    <></>
                )}
            </td>
        )
    }

    return (
        <Tooltip openDelay={100} position="bottom" anchorElement="pointer">
            <Grid data={props.dataItem.annualTests} detail={DefectGrid} expandField="expanded">
                <GridColumn field="expanded" cell={ExpandSelectionCell} width="40px" headerCell={() => <></>} />
                <GridColumn field="testDate" cell={DateFormatCell} title="Test date" />
                <GridColumn field="testType" title="Test type" cell={TooltipCell} />
                <GridColumn field="testResult" title="Test result" cell={TooltipCell} />
                <GridColumn field="testCertificateNumber" title="Certificate number" />
                <GridColumn field="expiryDate" cell={DateFormatCell} title="Expiry date" />
                <GridColumn field="numberOfDefectsAtTest" title="Defects" width={85} />
                <GridColumn field="numberOfAdvisoryDefectsAtTest" title="Advisory defects" width={140} />
                <GridColumn field="location" title="Location" cell={TooltipCell} width={400} />
            </Grid>
        </Tooltip>
    )
}
